var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"pp-card-title",attrs:{"data-cy":"card-title"}},[_vm._v("Servel")]),_c('p',{staticClass:"pp-card-description"})]),(_vm.hasPartido)?_c('chart-party'):_c('panel-box')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }